export enum EEventType {
  CREATED = 'created',
  MODIFIED = 'modified',
  DELETED = 'deleted',
  ADDED = 'added',
  REMOVED = 'removed',
  Archived = 'archived',
}
